import { View, Platform } from "react-native";
import { colors } from "../theme/tokens";

type Props = {
  color?: string;
  size?: number;
};

export function GlowBullet({ color = colors.green, size = 6 }: Props) {
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        marginTop: 6,
        flexShrink: 0,
        backgroundColor: color,
        ...(Platform.OS === "web" && {
          boxShadow: `0 0 8px ${color}99`,
        }),
      }}
    />
  );
}
